(() => {
  'use strict';
  const i18n = JSON.parse(document.getElementById('FabienneTranslations')?.textContent || '{}');
  const routeRoot = i18n.root || window.Shopify?.routes?.root || '/';
  const root = routeRoot.endsWith('/') ? routeRoot : routeRoot + '/';
  let toastTimer, cartRecommendationBusy = false;
  function notify(message, error = false, bagLink = false) {
    let toast = document.querySelector('.native-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'native-toast';
      document.body.append(toast);
    }
    clearTimeout(toastTimer);
    toast.setAttribute('role', error ? 'alert' : 'status');
    const label = document.createElement('span');
    label.textContent = message;
    toast.replaceChildren(label);
    if (!error || bagLink) {
      const link = document.createElement('a');
      link.href = root + 'cart';
      link.textContent = i18n.viewBag;
      toast.append(link);
    }
    toast.classList.add('show');
    toastTimer = setTimeout(() => toast.classList.remove('show'), error ? 8000 : 5000);
  }
  window.FabienneNativeCart = { root, notify };
  try { const flash = window.sessionStorage.getItem('fabienne-cart-message'); if(flash){window.sessionStorage.removeItem('fabienne-cart-message');notify(flash,true,true);} } catch {}
  async function refreshBag() {
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.cart-count').forEach(node => node.textContent = cart.item_count);
      document.querySelectorAll('.cart-toggle, [data-native-bag]').forEach(node => node.setAttribute('aria-label', i18n.bag + ' · ' + cart.item_count));
    } catch { /* The add succeeded; a count refresh failure must not invite a duplicate add. */ }
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.quick-form') || !window.fetch) return;
    event.preventDefault();
    const cartRecommendation = form.matches('[data-cart-recommendation]');
    if (form.dataset.adding === 'true' || (cartRecommendation && cartRecommendationBusy)) return;
    const cartForm = cartRecommendation ? document.getElementById('cart') : null;
    if(cartForm && !cartForm.reportValidity()) return;
    const dirty = cartForm ? [...cartForm.querySelectorAll('input[name="updates[]"]')].filter(input=>input.value!==input.defaultValue) : [];
    const controls = cartRecommendation ? [...document.querySelectorAll('[data-cart-recommendation] button, #cart button, #cart input[name="updates[]"], .native-mobile-checkout button')].map(control=>({control,disabled:control.disabled})) : [];
    if(cartRecommendation){cartRecommendationBusy=true;controls.forEach(({control})=>control.disabled=true);}
    let cartChanged=false;
    const button = form.querySelector('button[type=submit]');
    const original = button.innerHTML;
    form.dataset.adding = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = i18n.adding;
    const restore = () => {
      button.innerHTML = original;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.classList.remove('is-added');
      delete form.dataset.adding;
      if(cartRecommendation){cartRecommendationBusy=false;controls.forEach(({control,disabled})=>control.disabled=disabled);}
    };
    try {
      for(const input of dirty){
        const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:input.dataset.lineKey,quantity:Number(input.value)})});
        const updated=await response.json();
        if(!response.ok)throw Object.assign(new Error(),{publicMessage:typeof updated.description==='string'?updated.description:i18n.addError});
        cartChanged=true;
      }
      const data = new FormData(form);
      data.delete('return_to');
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok) throw Object.assign(new Error(), { publicMessage: typeof result.description === 'string' ? result.description : i18n.addError });
      if(cartRecommendation){window.location.assign(root+'cart');return;}
      button.removeAttribute('aria-busy');
      button.textContent = i18n.added + ' ✓';
      button.classList.add('is-added');
      notify(i18n.addedToBag);
      refreshBag();
      setTimeout(restore, 1100);
    } catch (error) {
      if(cartChanged){try{window.sessionStorage.setItem('fabienne-cart-message',error.publicMessage||i18n.addError);}catch{}window.location.assign(root+'cart');return;}
      restore();
      notify(error.publicMessage || i18n.addError, true, cartRecommendation);
    }
  });
  function closeMenu() {
    const button = document.querySelector('.menu-toggle'), menu = document.querySelector('.mobile-menu');
    if (menu) menu.hidden = true;
    if (button) { button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-label', i18n.openMenu); }
    document.body.classList.remove('menu-open');
    const main = document.getElementById('main');
    if (main) main.inert = false;
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('.menu-toggle');
    if (toggle) {
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = !menu.hidden;
      document.body.classList.toggle('menu-open', open);
      const main = document.getElementById('main');
      if (main) main.inert = open;
      toggle.setAttribute('aria-label', open ? i18n.closeMenu : i18n.openMenu);
      if (open) menu.style.top = document.querySelector('.header').getBoundingClientRect().bottom + 'px';
    }
    if (event.target.closest('.mobile-shop-bar a, .mobile-menu a')) closeMenu();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && document.body.classList.contains('menu-open')) {
      closeMenu();
      document.querySelector('.menu-toggle')?.focus();
    }
  });
  window.addEventListener('resize', () => { if (innerWidth > 760) closeMenu(); });
})();
